export default {
  state: {
    type: 'week', //week healthy
  },
  mutations: {
    switchStatsType(state, type){
      state.type = type
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/statsStore.js